import { render } from "./PlanosBanner.vue?vue&type=template&id=c6afb822&scoped=true&ts=true"
import script from "./PlanosBanner.vue?vue&type=script&lang=ts"
export * from "./PlanosBanner.vue?vue&type=script&lang=ts"

import "./PlanosBanner.vue?vue&type=style&index=0&id=c6afb822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6afb822"]])

export default __exports__